import React, {
  Component,
  Fragment
} from 'react';

class Login extends Component {
  constructor(){
    super();

    this.state = {}
  }

  render() {
    let self = this;

    return (
      <Fragment>
        LOGIN
      </Fragment>
    );
  }
}

export default Login;
